import 'react-on-rails-pro/registerDefaultRSCProvider/client';
import ReactOnRails from 'react-on-rails-pro/client';
import ProductPageSSR from '../../startup/ProductPageSSR.tsx';

ReactOnRails.register({ProductPageSSR});